import { render } from "./CompanyDocument.vue?vue&type=template&id=617d9ad2"
import script from "./CompanyDocument.vue?vue&type=script&lang=js"
export * from "./CompanyDocument.vue?vue&type=script&lang=js"

import exportComponent from "D:\\GitLocal\\mvs-sys\\mvsui-user\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__